import { apiAuthGW } from "./api";


export const handleIsAuthenticatedApiSPID = async () => {
    return await apiAuthGW.get(`/auth/isAuthenticated`);
}

export const handleUserInfoApiSPID = async () => {
    return await apiAuthGW.get(`/auth/userInfo`)
}